import React, {useContext} from "react";
import { Grid, Mui } from "@leap4/frontend";
import {appDataGeneratorContext} from "./appDataGeneratorContext";
import {FormChipsControlled} from "../../formChipControl/FormChipsControlled";
import { appDataFieldsMap, appStoresIdentifier} from "./appData.interface";
import {ReportTable} from "../demandWLGenerator/reportTable";
import GlobalBundleInput from "../demands/base/globalBundleInput";

const { Typography, Button } = Mui;




const AppDataView = () => {
    const {
        appDataSearch,
        setAppDataSearch,
        validationErrors,
        setValidationErrors,
        runReport,
        isLoadingReport,
        reportData,
        reportColumns
    } = useContext(appDataGeneratorContext);

    return (
        <div>
                <Typography variant="h5" align="center">
                    Apps Data
                </Typography>
            <Grid container justifyContent="flex-start" alignItems={"flex-start"} textAlign="left">

                <Grid item xs={12} md={10} lg={10}>
                    {/* Dimensions */}
                    <FormChipsControlled
                        valueKey="key"
                        labelKey="value"
                        inputName="Dimensions*"
                        optionsList={appDataFieldsMap}
                        enableCreate={false}
                        pureCreate={false}
                        onUpdateItems={(items) => {
                            if(!items.find((item: any) => item === 'AppIdentifier')) {
                                items.unshift('AppIdentifier');
                            }
                            setAppDataSearch({
                                ...appDataSearch,
                                dimensions: items.map((item: any) => ({
                                    key: item,
                                    value: appDataFieldsMap.find((field) => field.key === item)?.value || item,
                                })),
                            });
                        }}
                        disableCloseOnSelect={false}
                        stackProps={{width: "100%"}}
                        controlledValue={appDataSearch.dimensions}
                        textFieldProps={ {error: !!validationErrors.dimensions, helperText: validationErrors.dimensions}}
                        chipStylingFn={(chip) => chip.key === 'AppIdentifier' ? { backgroundColor: "#E0E0E0", color: "#757575", opacity: 0.6, pointerEvents: "none" } : {}}

                    />
                </Grid>
                <Grid item={true} xs={12} md={10} lg={10}>
                    {/* App Identifier */}
                    <FormChipsControlled
                        valueKey="key"
                        labelKey="value"
                        inputName="Stores"
                        optionsList={appStoresIdentifier}
                        enableCreate={false}
                        pureCreate={false}
                        onUpdateItems={(items) => {
                            setAppDataSearch({
                                ...appDataSearch,
                                AppStoreIdentifier: items.map((item: any) => ({
                                    key: item,
                                    value: item,
                                })),
                            });
                        }}
                        disableCloseOnSelect={false}
                        stackProps={{width: "100%"}}
                        controlledValue={appDataSearch.AppStoreIdentifier}
                    />
                </Grid>
                <Grid item xs={12} md={10} lg={10}>
                    {/* bundle Identifier */}
                    <Grid item xs={6}>
                        <GlobalBundleInput
                            title={`Bundles (${appDataSearch.AppIdentifier?.length || 0})`}
                            error={validationErrors?.bundles}
                            setError={(error) => setValidationErrors((prevError) => ({ ...prevError, bundles: error }))}
                            globalBundleList={appDataSearch.AppIdentifier}
                            setBundleList={(list) => {
                                const uniqueList = Array.from(new Set(list));
                                setAppDataSearch({ ...appDataSearch, AppIdentifier: uniqueList })
                            }}
                            showExportButton={false}
                        />
                    </Grid>
                </Grid>
                {/* Run Report Button */}
                <Grid item xs={12} marginTop={2}>
                    <Button variant="outlined" onClick={()=>runReport(appDataSearch)} color="success" disabled={isLoadingReport}>
                        Run Report
                    </Button>
                </Grid>
                {isLoadingReport && (
                    <Grid item xs={12} marginTop={2}>
                        <Typography variant="body2">Loading...</Typography>
                    </Grid>
                )}
                {
                    reportData?.length === 0 && (
                        <Grid item xs={12} marginTop={2}>
                            <Typography variant="body2">No data found</Typography>
                        </Grid>
                    )
                }
                {reportData && (
                    <Grid item xs={12} marginTop={2}>
                        <ReportTable data={reportData} columns={reportColumns}/>
                    </Grid>
                )}

            </Grid>
        </div>
    );
};

export default AppDataView;
